export const dayStart = d => {
	let date = createDate(d);
	return dateToString(date)
}
export const dayEnd = d => {
	let date = createDate(d);
	date.setDate(date.getDate() + 1)
	return dateToString(date)
}
export const weekStart = d => {
	let date = createDate(d);
	let weekstart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - date.getDay());
	return dateToString(weekstart);
}
export const weekEnd = d => {
	let date = createDate(d);
	let weekend = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7 - date.getDay());
	return dateToString(weekend);
}
export const monthStart = d => {
	let date = createDate(d);
	let month = date.getMonth();
	let year = date.getFullYear();
	return dateToString(new Date(year, month, 1, 0))
}
export const monthEnd = d => {
	let date = createDate(d);
	let month = date.getMonth();
	let year = date.getFullYear();
	return dateToString(new Date(year, month + 1, 1, 0))
}
export const yearStart = d => {
	let date = createDate(d);
	let year = date.getFullYear();
	return dateToString(new Date(year, 0, 1, 0))
}
export const yearEnd = d => {
	let date = createDate(d);
	let year = date.getFullYear();
	return dateToString(new Date(year + 1, 0, 1, 0))
}
export const monthDays = d => {
	let date = new Date(d.getFullYear(), d.getMonth() + 1, 1);
	return (Number)(addDay(date, -1).toLocaleDateString().split('/')[2])
}
export const addDay = (d, num) => {
	let date = createDate(d);
	date.setDate(date.getDate() + num)
	return date
}

export const currentDay = d => {
	let date = createDate(d);
	return Number(date.toLocaleDateString().split('/')[2])
}

export const perDay = d => {
	let date = createDate(d);
	date.setDate(date.getDate() - 1)
	return date
}
export const nextDay = d => {
	let date = createDate(d);
	date.setDate(date.getDate() + 1)
	return date
}
export const perMonth = d => {
	let date = createDate(d);
	date.setMonth(date.getMonth() - 1)
	return date
}
export const nextMonth = d => {
	let date = createDate(d);
	date.setMonth(date.getMonth() + 1)
	return date
}

export const perYear = d => {
	let date = createDate(d);
	return new Date((date.getFullYear() - 1) + '')
}
export const nextYear = d => {
	let date = createDate(d);
	return new Date((date.getFullYear() + 1) + '')
}


function createDate(d) {
	return new Date(d.getTime())
}

function dateToString(d) {
	return d.toLocaleDateString().replace(/\//g, '-') + 'T00:00:00Z'
}


export function dateFormat(fmt, date) {
	let ret;
	const opt = {
		"Y+": date.getFullYear().toString(), // 年
		"m+": (date.getMonth() + 1).toString(), // 月
		"d+": date.getDate().toString(), // 日
		"H+": date.getHours().toString(), // 时
		"M+": date.getMinutes().toString(), // 分
		"S+": date.getSeconds().toString(), // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
		}
	}
	return fmt;
}